<div *ngIf="messages.length">

  <h2>Messages</h2>
  <button mat-raised-button (click)="clearMesssages()">Clear messages</button>
  <div *ngFor='let message of messages'> {{message}} </div>

</div>
